import React from "react";
import {
  FaUsers,
  FaUserCheck,
  FaUserTimes,
  FaUserClock,
} from "react-icons/fa";

const stats = [
  {
    title: "Total Employees",
    value: 120,
    icon: FaUsers,
    color: "from-blue-500 to-indigo-500",
  },
  {
    title: "Present Today",
    value: 98,
    icon: FaUserCheck,
    color: "from-green-500 to-emerald-500",
  },
  {
    title: "Absent Today",
    value: 15,
    icon: FaUserTimes,
    color: "from-red-500 to-rose-500",
  },
  {
    title: "Late Check-ins",
    value: 7,
    icon: FaUserClock,
    color: "from-yellow-500 to-orange-500",
  },
];

const DashboardHome = () => {
  return (
    <div className="space-y-6">
      {/* Header Card */}
      <div className="bg-white/70 backdrop-blur-md rounded-2xl shadow-lg p-6 border border-white/30">
        <h2 className="text-2xl font-bold text-slate-800">
          Dashboard Overview
        </h2>
        <p className="text-slate-500 mt-1">
          Welcome to <span className="font-semibold">BillTrace Attendance System</span>
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
        {stats.map((item, index) => {
          const Icon = item.icon;
          return (
            <div
              key={index}
              className="bg-white/70 backdrop-blur-md rounded-2xl shadow-md p-5 border border-white/30 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-slate-500">{item.title}</p>
                  <h3 className="text-2xl font-bold text-slate-800 mt-1">
                    {item.value}
                  </h3>
                </div>

                <div
                  className={`p-3 rounded-xl text-white bg-gradient-to-r ${item.color} shadow`}
                >
                  <Icon size={20} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardHome;